import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';

import { ITranslation } from '../interfaces';
import { bind } from '@infra/container';

export type IGetTranslationByIdRepoResponse = IRepoResponse<200, any> | IRepoResponse<400 | 500, string>;

export type IGetTranslationByIdRepo = IRepo<[string], IGetTranslationByIdRepoResponse>;

export const GetTranslationByIdRepoType = Symbol.for('GetTranslationByIdRepo');

@bind(GetTranslationByIdRepoType)
export class GetTranslationByIdRepo implements IGetTranslationByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker(`/translations`, { 'filters[id]': id }) });

      if (result.status === 200) {
        const response: ITranslation[] = result.data.data;
        return {
          status: 200 as 200,
          response: response,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
